import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import Login from '@/pages/Login'
import ForgotPassword from '@/pages/ForgotPassword'
import ResetPassword from '@/pages/ResetPassword'
import Home from '@/pages/Home'
import BillingHistory from '@/pages/BillingHistory'
import { KillSwitchConfirmDialog } from '@/components/shared/KillSwitchConfirmDialog'

// Nexus Admin Pages
import {
  NexusLogin,
  NexusLayout,
  NexusDashboard,
  NexusUsers,
  NexusAbilities,
  NexusAPIServices,
  NexusRevenue, NexusUserDetail,
} from '@/pages/nexus'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, fetchUser } = useAuthStore()

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-light-bg dark:bg-dark-bg">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-navy border-t-transparent rounded-full animate-spin mx-auto" />
          <p className="mt-4 text-light-text-secondary dark:text-dark-text-secondary">
            Loading...
          </p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* User Authentication */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Nexus Admin Routes */}
        <Route path="/nexus/login" element={<NexusLogin />} />
        <Route path="/nexus" element={<NexusLayout />}>
          <Route index element={<Navigate to="/nexus/dashboard" replace />} />
          <Route path="dashboard" element={<NexusDashboard />} />
          <Route path="users" element={<NexusUsers />} />
          <Route path="users/:id" element={<NexusUserDetail />} />
          <Route path="abilities" element={<NexusAbilities />} />
          <Route path="api-services" element={<NexusAPIServices />} />
          <Route path="revenue" element={<NexusRevenue />} />
        </Route>

        {/* Billing History */}
        <Route
          path="/billing"
          element={
            <ProtectedRoute>
              <BillingHistory />
            </ProtectedRoute>
          }
        />

        {/* Main App */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Global Dialog */}
      <KillSwitchConfirmDialog />
    </BrowserRouter>
  )
}

export default App
